import * as I18n from 'i18n-js';
import * as React from 'react';
import { IUserContext, withUserContext } from '@reverbdotcom/commons/dist/components/user_context_provider';
import * as classNames from 'classnames';
import bind from '@reverbdotcom/commons/dist/bind';

interface Props extends IUserContext {
  openModal: () => void;
  disabled: boolean;
  isFollowing: boolean;
  unstyled?: boolean;
  addText?: string;
  addedText?: string;
  disabledTooltipText?: string;
  followParams?: Record<string, any>;
  outlined?: boolean;
}

export class FollowButton extends React.Component<Props, null> {
  getDefaultText() {
    return I18n.t(
      'discovery.addFollowToFeed.followThis',
      { type: I18n.t('discovery.addFollowToFeed.followType.search') },
    );
  }

  getDefaultAddedText() {
    return I18n.t('discovery.addFollowToFeed.hasAddedToFeed');
  }

  @bind
  handleClick(e) {
    e.preventDefault();

    if (this.props.disabled) {
      return;
    }

    this.props.openModal();
  }

  linkText() {
    if (this.props.isFollowing) {
      return this.props.addedText || this.getDefaultAddedText();
    }

    return this.props.addText || this.getDefaultText();
  }

  tooltipText() {
    if (!this.props.disabled) { return null; }

    return this.props.disabledTooltipText ||
      I18n.t('discovery.addFollowToFeed.tooltipText');
  }

  render() {
    const classes = classNames(
      'feed-button__follow',
      { 'feed-button__follow--styled': !this.props.unstyled && !this.props.outlined },
      { 'feed-button__follow--outlined': this.props.outlined },
      { 'feed-button__follow--remove': this.props.isFollowing },
    );

    return (
      <div
        data-tooltip-text={this.tooltipText()}
      >
        <a
          className={classes}
          onClick={this.handleClick}
          role="button"
          data-disabled={this.props.disabled || null}
        >
          {this.linkText()}
        </a>
      </div>
    );
  }
}

export default withUserContext(FollowButton);



// WEBPACK FOOTER //
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/src/components/discovery/feed/follow_button.tsx